export type BucketMode = 'self' | 'family' | 'gift'

export type TasteId =
  | 'freeze-dried'
  | 'fruity'
  | 'sour'
  | 'chocolate'
  | 'caramel'

export type Adventure = 'safe' | 'one_wildcard' | 'wild'

export const MIN_TARGET_SPEND_CENTS = 2500

export interface BucketProduct {
  readonly id: string
  readonly name: string
  readonly image: string
  readonly priceCents: number
  readonly tags: readonly TasteId[]
}

export interface ComposeInput {
  readonly mode: BucketMode
  readonly likes: readonly TasteId[]
  readonly hardNos: readonly TasteId[]
  readonly adventure: Adventure
  readonly targetSpendCents: number
}

export interface BucketLine {
  readonly productId: string
  readonly name: string
  readonly image: string
  readonly priceCents: number
  readonly quantity: 1
  readonly reason: string
}

export interface BucketComposition {
  readonly id: string
  readonly name: string
  readonly lines: readonly BucketLine[]
  readonly subtotalCents: number
  readonly status: 'ready' | 'no_match'
  readonly inventoryStatus: 'demo_unverified'
}
